import React from "react";
import NuotoCorsiSezioni from "../../components/corsi_nuoto/NuotoCorsiSezioni";
import CaroselloStandard from "../../commons/CaroselloStandard";
import corsi from "../../images/Nuoto/corsiNuoto/IMG_8526-3.jpg"
import foto1 from "../../images/Nuoto/corsiNuoto/IMG_8604.jpg"
import foto2 from "../../images/Nuoto/corsiNuoto/IMG_8552.jpg"
import foto5 from "../../images/Nuoto/corsiNuoto/IMG_8577.jpg";
import foto6 from "../../images/Nuoto/corsiNuoto/IMG_8590.jpg";
import foto7 from "../../images/Nuoto/corsiNuoto/IMG_1747.jpg";
import foto3 from "../../images/Nuoto/corsiNuoto/IMG_7361-3.jpg";
import foto4 from "../../images/Nuoto/corsiNuoto/IMG_1760-2.jpg";
import Titolo from "../../commons/Titolo";
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import {useNavigate} from "react-router-dom";
import Spa from "../Spa";
import Space from "../../commons/Space";
import CosaPortareNuoto from "../../components/corsi_nuoto/CosaPortareNuoto";
import GenitoriAttivi from "../../commons/GenitoriAttivi";
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import SpaceL from "../../commons/SpaceL";
import snf from "../../images/Nuoto/corsiNuoto/Logo_SNF.jpg";
import fin from "../../images/logo/Fin.svg";
import certificato from "../../images/Nuoto/corsiNuoto/licenza_snf_2025.png";
import "../../styles/CorsiNuoto.css"
import calendario from "../../images/Calendario_2023_2024.jpg";
import AllertIscrizione from "../../components/multitessere/AllertIscrizione";
import NuotoAccPrezzi from "../../components/corsi_nuoto/NuotoAccPrezzi";




function NuotoCorsi() {
    const navigate = useNavigate()
    return(
        <div>
            <ScrollToTopOnMount />
            <Titolo backgroundImage={corsi} title={"Corsi Nuoto"}/>
            <FrecciaIndietro indirizzo={"/piscina"} />
            <div className="text-center">
                <img className="m-auto" src={snf} style={{height: "5em"}}/>
            </div>
            <div style={{padding: "0 1em 1em 1em"}}>
            <br/>


            <figure className="text-center">
                <blockquote className="blockquote">
                    <p>
                        <h3>Corsi mono o bi settimanali con personale qualificato e brevettato <img className="m-auto" src={fin} style={{height: "1em", marginLeft: "10px"}}/></h3>
                        <h4>Modulati per età e preparazione tecnica</h4>
                        <br/>
                        <h4>Adatti a chiunque voglia imparare a nuotare o perfezionare gli stili</h4>
                    </p>
                </blockquote>
            </figure>
            <SpaceL />

            <NuotoCorsiSezioni />
                {/*
            <Space />

                <NuotoAccPrezzi />
                {/*
            <div className="text-center">
                <a style={{alignSelf: "end", cursor:"pointer", fontSize: "22px", fontFamily: "Hammersmith One", color: "#032041"}} href="/documents/Listini/ListinoCorsiNuoto.pdf" download>Prezzi corsi nuoto</a>
            </div>

            <br />
                <AllertIscrizione />
                */}
                <Space />
            <CosaPortareNuoto />
            <Space />
                {/*
            <GenitoriAttivi />
                    */}
            <Space />
            <CaroselloStandard foto1={foto1} foto2={foto2} foto3={foto3} foto4={foto4} foto5={foto5} foto6={foto6} foto7={foto7}/>
            <Space />
                <div className="m-auto d-flex flex-row justify-content-center">
                    <img style={{boxShadow: "15px 15px 20px rgba(0, 0, 0, 0.5)"}} src={certificato} className="img-fluid img-thumbnail certificato-img"  alt="..." />
                </div>

                <Space />
            </div>
        </div>
    )
}


export default NuotoCorsi
